import styled from '@emotion/styled';
import { TextLabel, H2 } from 'ds/components/typography';
import { colorToAlpha } from 'helpers/insight';
import { CompletionType } from 'utils/entities';

export const MapWrapper = styled.div`
  position: relative;
  width: 100vw;
  height: 270px;
`;

export const MapMask = styled.div`
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 115px;
  background: linear-gradient(0deg, white 60%, transparent 100%);
  z-index: 1;
`;

export const PageInfoWrapper = styled.div`
  position: relative;
  display: flex;
  align-items: center;

  ${({ theme }) => theme.media.showAt({ at: 1 })`
    margin-bottom: ${theme.spacing(5)};
  `}

  ${({ theme }) => theme.media.showAt({ from: 2 })`
    padding-top: ${theme.spacing(4)};
    margin-bottom: ${theme.spacing(8)};
  `}

  ${({ theme }) => theme.media.showAt({ at: 2 })`
    padding-left: ${theme.spacing(6)};
    padding-right: ${theme.spacing(6)};
  `}

  ${({ theme }) => theme.media.showAt({ from: 3 })`
    padding-left: ${theme.spacing(4)};
    padding-right: ${theme.spacing(4)};
  `}
`;

export const PageInfo = styled.div`
  position: relative;
  flex: 1;
  ${({ theme }) => theme.media.showAt({ from: 2 }) `
    margin-${theme.isRTL ? 'right' : 'left'}: ${theme.spacing(2.5)};
  `}

  ${({ theme }) => theme.media.showAt({ at: 1 })`
    position: absolute;
    bottom: 0;
    left: 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    z-index: 2;
  `}
`;

export const PageTypeLabel = styled(TextLabel)<{ type?: CompletionType }>`
  ${({ theme, type }) => `
    display: inline;
    vertical-align: middle;
    background: ${type === CompletionType.EmploymentArea ? theme.colors.label.yellow : theme.colors.brand.darker};
    &&& {
      color: ${type === CompletionType.EmploymentArea ? theme.colors.neutrals.grey1 : theme.colors.neutrals.white};
    }
    padding: 4px 4px 2px;
    border-radius: ${theme.borderRadius.tiny};
  `}
`;

export const PageTypeLabelWrapper = styled(H2)`
  display: inline;
  line-height: 21px;
  ${({ theme }) => theme.media.showAt({ at: 1 })`
    margin-bottom: ${theme.spacing(2)};
  `}
`;

export const ShareButtonWrapper = styled.div`
  ${({ theme }) => `
    float: ${theme.isRTL ? 'left' : 'right'};
    margin-${theme.isRTL ? 'right' : 'left'}: ${theme.spacing(2)};
    .share-button {
      padding: 0 ${theme.spacing(1.5)};
      box-shadow: none;
      height: 32px;
      border-radius: ${theme.borderRadius.small};
      border: solid 1px ${theme.colors.neutrals.grey9};

      div {
        font-size: 13px;
        color: ${theme.colors.neutrals.grey2};
      }

      svg {
        width: 16px;
        height: 16px;
        path {
          fill: ${theme.colors.neutrals.grey1};
        }
      }
    }
  `}
`;

export const IconFrame = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate3d(-50%, -100%, 0);
  z-index: 5;
`;

export const FrameDot = styled.div`
  position: relative;
  width: 8px;
  height: 8px;
  border-radius: ${props => props.theme.borderRadius.round};
  margin: 0 auto;
  background-color: ${({ theme }) => theme.colors.brand.darker};

  &::after {
    content: '';
    top: -3px;
    left: -3px;
    position: absolute;
    width: 8px;
    height: 8px;
    border-radius: ${props => props.theme.borderRadius.round};
    border: solid 3px ${({ theme }) => colorToAlpha(theme.colors.brand.darker, 0.12)};
  }
`;

export const IconFrameWrapper = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  padding: 15px 15px 30px;
`;

export const H1Label = styled(H2.withComponent('h1'))`
  display: inline;
  ${({ theme }) => theme.media.showAt({ from: 2 }) `
    margin-${theme.isRTL ? 'left' : 'right'}: ${theme.spacing(1.5)};
  `}
  ${({ theme }) => theme.media.showAt({ at: 1 })`
    display: block;
    text-align: center;
    margin: 0 ${theme.spacing(2)};
  `}
`;

export const LabelWrapper = styled.div`
  ${({ theme }) => `
    color: ${theme.colors.neutrals.grey1};
  `}
  ${({ theme }) => theme.media.showAt({ at: 1 })`
    display: flex;
    flex-direction: column-reverse;
    align-items: center;
  `}
`;

export const OpenMapIconWrapper = styled.div`
  position: absolute;
  z-index: 2;
  right: ${({ theme }) => theme.spacing(2)};
  top: ${({ theme }) => theme.spacing(2)};
`;
